import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [
  {
    path: "/admin/dashboard/main",
    title: "Dashboard",
    iconType: "material-icons-two-tone",
    icon: "description",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
    moduleId:0
  },

  // Admin Modules
  // {
  //   path: "",
  //   title: "MENUITEMS.DASHBOARD.TEXT",
  //   iconType: "material-icons-two-tone",
  //   icon: "space_dashboard",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/admin/dashboard/main",
  //       title: "MENUITEMS.DASHBOARD.LIST.DASHBOARD1",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/dashboard/dashboard2",
  //       title: "MENUITEMS.DASHBOARD.LIST.DASHBOARD2",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },

 
  // Common Modules

  // {
  //   path: "",
  //   title: "Authentication",
  //   iconType: "material-icons-two-tone",
  //   icon: "supervised_user_circle",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/authentication/signin",
  //       title: "Sign In",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/signup",
  //       title: "Sign Up",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/forgot-password",
  //       title: "Forgot Password",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/locked",
  //       title: "Locked",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/page404",
  //       title: "404 - Not Found",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/page500",
  //       title: "500 - Server Error",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
//   {
//     path: "/admin/dashboard/main",
//     title: "CONFIGURATION",
//     iconType: "font-icon",
//     icon: "fas fa-address-book yellow_color",
//     class: "menu-toggle",
//     groupTitle: false,
//     badge: "",
//     badgeClass: "",
//     role: ["Admin"],
//     submenu: [
//       {
//     path: "/multilevel/first1",
//     title: "Enterprise Setup",
//     iconType: "", 
//     icon: "fas fa-project-diagram submenu-icon",
//     class: "ml-sub-menu",
//     groupTitle: false,
//     badge: "",
//     badgeClass: "",
//     role: [""],
//     submenu: [
//       {
//         path: "/coremodule/Groupview",
//         title: "Group view",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/LegalEntitys",
//         title: "Legal Entitys",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/BusinessSegment",
//         title: "Business Segment",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/BusinessArea",
//         title: "Business Area",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/Departments",
//         title: "Department",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//     ]
//       },
//       {
//         path: "/multilevel/first1",
//         title: "Account Configuration",
//         iconType: "", 
//         icon: "fas fa-user-cog submenu-icon",
//         class: "ml-sub-menu",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [
//           {
//             path: "/coremodule/ViewChartofAccount",
//             title: "View COA",
//             iconType: "",
//             icon: "",
//             class: "ml-menu2",
//             groupTitle: false,
//             badge: "",
//             badgeClass: "",
//             role: [""],
//             submenu: [],
//           },
//         ]
//       }
//     ]
//   },
//   {
//     path: "/admin/dashboard/main",
//     title: "SECURITY",
//     iconType: "",
//     icon: "fas fa-shield-alt blue_color",
//     class: "menu-toggle",
//     groupTitle: false,
//     badge: "",
//     badgeClass: "",
//     role: ["Admin"],
//     submenu: [
//       {
//     path: "/multilevel/first1",
//     title: "Permission",
//     iconType: "", 
//     icon: "fas fa-user-shield submenu-icon",
//     class: "ml-sub-menu",
//     groupTitle: false,
//     badge: "",
//     badgeClass: "",
//     role: [""],
//     submenu: [
//       {
//         path: "/coremodule/userWiseViewPermission",
//         title: "Set Permission",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//     ]
//       }
//     ]
//   },
      
//   {
//     path: "/admin/dashboard/main",
//     title: "MASTER",
//     iconType: "material-icons-two-tone",
//     icon: "fas fa-user-graduate blue_color ",
//     class: "menu-toggle",
//     groupTitle: false,
//     badge: "",
//     badgeClass: "",
//     role: ["Admin"],
//     submenu: [
//       {
//     path: "/multilevel/first1",
//     title: "General Master",
//     iconType: "", 
//     icon: "fas fa-user-circle submenu-icon",
//     class: "ml-sub-menu",
//     groupTitle: false,
//     badge: "",
//     badgeClass: "",
//     role: [""],
//     submenu: [
//       {
//         path: "/coremodule/organizationType",
//         title: "Organization Type",
//         iconType: "",
//         icon: "fas fa-user submenu-icon",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/CorporateStatus",
//         title: "Corporate Status",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/location",
//         title: "Location",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },  
//       {
//         path: "/coremodule/Department",
//         title: "Department",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },  
//       {
//         path: "/coremodule/Rolemaster",
//         title: "Role Master",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       }, 
//       {
//         path: "/coremodule/ActivityMaster",
//         title: "Activity Master",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/PermissionMaster",
//         title: "Permission Master",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/CodeMaster",
//         title: "Code Master",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//       {
//         path: "/coremodule/Designation",
//         title: "Designation",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
     
// ],
// },
// {
//   path: "/multilevel/first1",
//     title: "Account Master",
//     iconType: "", 
//     icon: "fas fa-user-check submenu-icon",
//     class: "ml-sub-menu",
//     groupTitle: false,
//     badge: "",
//     badgeClass: "",
//     role: [""],
//     submenu: [
//       {
//         path: "/coremodule/MasterSchedule",
//         title: "Master Schedule",
//         iconType: "",
//         icon: "",
//         class: "ml-menu2",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [],
//       },
//     ]
// },
// {
//         path: "/multilevel/first1",
//         title: "Item Master",
//         iconType: "", 
//         icon: "fas fa-user-plus submenu-icon",
//         class: "ml-sub-menu",
//         groupTitle: false,
//         badge: "",
//         badgeClass: "",
//         role: [""],
//         submenu: [
//           {
//             path: "/coremodule/ItemMaster",
//             title: "Item Management",
//             iconType: "",
//             icon: "",
//             class: "ml-menu2",
//             groupTitle: false,
//             badge: "",
//             badgeClass: "",
//             role: [""],
//             submenu: [],
//           },
//           {
//             path: "/coremodule/BrandMaster",
//             title: "Brand Master",
//             iconType: "",
//             icon: "",
//             class: "ml-menu2",
//             groupTitle: false,
//             badge: "",
//             badgeClass: "",
//             role: [""],
//             submenu: [],
//           },
//     ],
//   },
// ]

// },
// {
//   path: "/hrms",
//   title: "HRMS",
//   iconType: "material-icons-two-tone",
//   icon: "fas fa-user-tie red_color",
//   class: "menu-toggle",
//   groupTitle: false,
//   badge: "",
//   badgeClass: "",
//   role: ["Admin"],
//   submenu: [
//     {
//       path: "/hrms/viewEmployee",
//       title: "Employee List",
//       iconType: "", 
//       icon: "",
//       class: "ml-menu2",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/hrms/employeeReg",
//       title: "Employee Registration",
//       iconType: "", 
//       icon: "",
//       class: "ml-menu2",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/hrms/EmployeeCenter",
//       title: "Employee Center",
//       iconType: "", 
//       icon: "",
//       class: "ml-menu2",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//   ]
// },

// {
//   path: "/patientscare",
//   title: "PATIENTS CARE",
//   iconType: "material-icons-two-tone",
//   icon: "fas fa-procedures orange_color",
//   class: "menu-toggle",
//   groupTitle: false,
//   badge: "",
//   badgeClass: "",
//   role: ["Admin"],
//   submenu: [
//     {
//       path: "/patientscare/PatientRegistration",
//       title: "Patient Registration",
//       iconType: "", 
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/viewPatients",
//       title: "Patient List",
//       iconType: "", 
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/MasterCardDisplay",
//       title: "Master Card Display",
//       iconType: "", 
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/PatientMasterData",
//       title: "Patient Master Data",
//       iconType: "", 
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/PatientTicket",
//       title: "OPD Patient Ticket",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/PatientCounselling",
//       title: "Patient Counselling",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
    
//     {
//       path: "/patientscare/PatientOPDIntialScreening",
//       title: " OPD Initial Screening",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/PatientOPDQueingTracker",
//       title: " OPD Queuing Tracker",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/DrConsulation",
//       title: "Dr Consultation",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/DrSchedule",
//       title: "Dr Schedule",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/EmergencyPatientTicket",
//       title: "Emergency Patient Ticket",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/EmergencyInitialscreen",
//       title: "Emergency Initial Screen",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/EmergencyPatientsStatus",
//       title: "Emergency Patients Status",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },
//     {
//       path: "/patientscare/DrEmergencyObservation",
//       title: "Dr Emergency Observation",
//       iconType: "",
//       icon: "",
//       class: "ml-menu",
//       groupTitle: false,
//       badge: "",
//       badgeClass: "",
//       role: [""],
//       submenu: [],
//     },

//   ]
// },



  // {
  //   path: "/admin/dashboard/main",
  //   title: "PROCURE TO PAY",
  //   iconType: "material-icons-two-tone",
  //   icon: "fas fa-syringe yellow_color",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/multilevel/first1",
  //       title: "Purchase Requisition",
  //       iconType: "", 
  //       icon: "",
  //       class: "ml-sub-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [
  //         {
  //           path: "/prpo/PRstoreTracker",
  //           title: "PR Store Tracker",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/PurchaseRequistion",
  //           title: "Procurement Request",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
         
  //         // {
  //         //   path: "/prpo/QuatationInput",
  //         //   title: "Quotation Inputs",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         {
  //           path: "/prpo/QuatationAnalysis",
  //           title: "Quotation Analysis",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/QuatationFinalise",
  //           title: "Quotation Finalise",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/BudgetCheck",
  //           title: "Budget check page",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/PRApproval",
  //           title: "PR Approval",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/PRStatus",
  //           title: "PR Status",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/PrTracker",
  //           title: "PR Tracker",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
          
  //       ],
  //     },
  //     {
  //       path: "/multilevel/first2",
  //       title: "Purchase Order",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-sub-menu",
      
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [ 
  //         {
  //           path: "/prpo/PODraft",
  //           title: "PO Draft",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/PoValidate",
  //           title: "PO Validate",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/PoApproval",
  //           title: "PO Approval",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/PoDisplay",
  //           title: "PO Display",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
        
  //       ],
  //     },
  //     {
  //       path: "/multilevel/first2",
  //       title: "Invoice Processing",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-sub-menu",
      
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [ 
  //         {
  //           path: "/multilevel/secondlevel/second1",
  //           title: "PO Fullfilment",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-sub-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [
  //             {
  //               path: "/prpo/PoTracker",
  //               title: "PO tracker",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/PoOpen",
  //               title: "Open PO",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/PoFullfilment",
  //               title: "PO Fullfilment",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/PosubmitFullfilment",
  //               title: "PO Submit ",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/PoValidateFullfilment",
  //               title: "PO Validate",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/PoFullfilmentApprove",
  //               title: "PO Approve",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             // {
  //             //   path: "/prpo/abc",
  //             //   title: "Requisition-Create",
  //             //   iconType: "",
  //             //   icon: "",
  //             //   class: "ml-menu",
  //             //   groupTitle: false,
  //             //   badge: "",
  //             //   badgeClass: "",
  //             //   role: [""],
  //             //   submenu: [],
  //             // },
  //             {
  //               path: "/prpo/PoFullfilmentPrint",
  //               title: "PO Print",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //           ],
  //         },
  //         {
  //           path: "/multilevel/secondlevel/second1",
  //           title: "Invoice processing",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-sub-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [
  //             {
  //               path: "/prpo/InvoiceProcessing",
  //               title: "Invoice Processing",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/InvoiceProcesscheck",
  //               title: "Invoice Check",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/SubmitInvoice",
  //               title: "Submit Invoice",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/ValidateInvoice",
  //               title: "Validate Invoice",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/ApproveInvoice",
  //               title: "Approve Invoice",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
  //             {
  //               path: "/prpo/InvoiceProcessedDisplay",
  //               title: "Invoice Display",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               role: [""],
  //               submenu: [],
  //             },
          
  //           ],
  //         },
  //         // {
  //         //   path: "/multilevel/secondlevel/second1",
  //         //   title: "Work Certification",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   // class: "ml-sub-menu2",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [
  //         //     {
  //         //       path: "/prpo/",
  //         //       title: "Open Invoice processing",
  //         //       iconType: "",
  //         //       icon: "",
  //         //       class: "ml-menu3",
  //         //       groupTitle: false,
  //         //       badge: "",
  //         //       badgeClass: "",
  //         //       role: [""],
  //         //       submenu: [],
  //         //     },
  //         //   ],
  //         // },
  //         // {
  //         //   path: "/multilevel/secondlevel/second1",
  //         //   title: "Open Invoice processing",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //       ],
  //     },
  //     {
  //       path: "/multilevel/first3",
  //       title: "Bill Payment",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-sub-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [
  //         {
  //           path: "/prpo/VendorPayment",
  //           title: "Vendor Payment",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         // {
  //         //   path: "/prpo/PaymentProcess",
  //         //   title: "Payment Process",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/SubmitPaymentProcess",
  //         //   title: "Submit Payment Process",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/PaymentValidate",
  //         //   title: "Payment Validate",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/ApprovedPayment",
  //         //   title: "Payment Approved",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/PaymentDisplay",
  //         //   title: "Payment Display",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         {
  //           path: "/prpo/PaymentTarcker",
  //           title: "Payment Tarcker",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //       ],
  //     },
  //     {
  //       path: "/multilevel/first3",
  //       title: "Vendor Management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-sub-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [
  //         {
  //           path: "/prpo/VendorEmpanelment",
  //           title: "Vendor Empanelment",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/VendorMasterTracker",
  //           title: "Vendor Tracker",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         // {
  //         //   path: "/prpo/VendorMasterDetails",
  //         //   title: "Vendor Master",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu3",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/VendorValidate",
  //         //   title: "Vendor Validate",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/VendorCreationApproval",
  //         //   title: "Vendor Approval",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/VendorCreatedDisplay",
  //         //   title: "Vendor Display",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         {
  //           path: "/prpo/RateContractOpen",
  //           title: "Rate Contract Open",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         // {
  //         //   path: "/prpo/RateContractBidding",
  //         //   title: "Rate Contract Bidding",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/RateContractProcess",
  //         //   title: "Rate Contract Process",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/OpenRateContractAnalysis",
  //         //   title: "Open Rate Contract Analysis",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/RateContractApproved",
  //         //   title: "Rate Contract Approved",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/RateContractDisplay",
  //         //   title: "Rate Contract Display",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         {
  //           path: "/prpo/RateTracker",
  //           title: "Rate Tracker",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/OpenVendorReco",
  //           title: "Open Reconciliation",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         // {
  //         //   path: "/prpo/MatchVendorReco",
  //         //   title: "Matching Reconciliation",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/UnMatchVendorReco",
  //         //   title: " UnMatched Reconciliation",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/AdjustVendorReco",
  //         //   title: "Reconciliation Adjustment",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         // {
  //         //   path: "/prpo/AdjustApproval",
  //         //   title: "Reconciliation Adjustment Approval",
  //         //   iconType: "",
  //         //   icon: "",
  //         //   class: "ml-menu2",
  //         //   groupTitle: false,
  //         //   badge: "",
  //         //   badgeClass: "",
  //         //   role: [""],
  //         //   submenu: [],
  //         // },
  //         {
  //           path: "/prpo/VendorRecoStatus",
  //           title: "Reconciliation Status",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/prpo/recontracker",
  //           title: "Reconciliation Tracker",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //       ],
  //     },
  //   ],
  // },


  // {
  //   path: "",
  //   title: "INVENTORY MANAGEMENT",
  //   iconType: "demo-google-material-icon",
  //   icon: "fas fa-hospital green_color",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/inventory-management/RequisitionCreate",
  //       title: "Requisition-Create",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     // {
  //     //   path: "/inventory-management/RequisitionValidate",
  //     //   title: "Requisition-Validate",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     // {
  //     //   path: "/inventory-management/RequisitionApprove",
  //     //   title: "Requisition-Approve",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     {
  //       path: "/inventory-management/RequisitionTracker",
  //       title: "Requisition-Tracker",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //      {
  //       path: "/inventory-management/CentralStoreReview",
  //       title: "Central-Store-Review",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     // {
  //     //   path: "/inventory-management/GoodsAvailableStatus",
  //     //   title: "Goods-Available-Status",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     // {
  //     //   path: "/inventory-management/GoodsAvailableIssue",
  //     //   title: "Goods-Available-Issue",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     // {
  //     //   path: "/inventory-management/GoodsIssue",
  //     //   title: "Goods-Issue",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     // {
  //     //   path: "/inventory-management/GoodsIssueApproval",
  //     //   title: "Goods-Issue-Approval",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     // {
  //     //   path: "/inventory-management/GoodsIssueNote",
  //     //   title: "Goods-Issue-Note",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     {
  //       path: "/inventory-management/StoreTracker",
  //       title: "Store-Tracker",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     // {
  //     //   path: "/inventory-management/IndividualRequisition",
  //     //   title: "Individual-Requisition",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     // {
  //     //   path: "/inventory-management/IntegrationRequisition",
  //     //   title: "Integration-Requisition",
  //     //   iconType: "",
  //     //   icon: "",
  //     //   class: "ml-menu",
  //     //   groupTitle: false,
  //     //   badge: "",
  //     //   badgeClass: "",
  //     //   role: [""],
  //     //   submenu: [],
  //     // },
  //     {
  //       path: "/inventory-management/StoreRequisition",
  //       title: "Store-Requisition",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ]
  // },


  // {
  //   path: "",
  //   title: "Extra Pages",
  //   iconType: "material-icons-two-tone",
  //   icon: "description",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/extra-pages/blank",
  //       title: "Blank Page",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
    
  //   ],
  // },
  
];
